import React from 'react'
import styles from './ProductCard.module.scss'
import { LockIcon } from '../../../../../components/CustomIcons'

const ProductCard = ({ product, onAddToCart, onClick, isAuthenticated }) => {
  const handleAddToCart = (e) => {
    e.stopPropagation()
    if (!isAuthenticated) {
      alert('Требуется авторизация')
      window.location.href = '/login'
      return
    }
    onAddToCart(product.slug || product.id)
  }

  const getButtonText = () => {
    if (!isAuthenticated) return <><LockIcon size={14} style={{ marginRight: '4px' }} /> Требуется авторизация</>
    if (product.stock <= 0) return 'Нет в наличии'
    return 'В корзину'
  }

  return (
    <div className={styles.card} onClick={() => onClick(product)}>
      <div className={styles.imageContainer}>
        <img 
          src={product.main_image || product.image || '/placeholder-product.jpg'} 
          alt={product.name}
          className={styles.image}
        />
        {product.discount_percentage && (
          <div className={styles.discount}>
            -{product.discount_percentage}%
          </div>
        )}
      </div>
      
      <div className={styles.content}>
        <h3 className={styles.name}>{product.name}</h3>
        <p className={styles.description}>
          {product.description?.substring(0, 100)}...
        </p>
        
        <div className={styles.price}>
          {product.discount_price && product.discount_price !== product.current_price && (
            <span className={styles.originalPrice}>{product.price} сом</span>
          )}
          <span className={styles.currentPrice}>{product.current_price || product.price} сом</span>
        </div>
        
        <div className={styles.meta}>
          <div className={styles.rating}>
            ★ {product.rating_avg || 'N/A'}
          </div>
          <div className={styles.stock}>
            {product.stock > 0 ? 'В наличии' : 'Нет в наличии'}
          </div>
        </div>
        
        <button 
          className={styles.addButton}
          onClick={handleAddToCart}
          disabled={!isAuthenticated ? false : !(product.stock > 0)}
        >
          {getButtonText()}
        </button>
      </div>
    </div>
  )
}

export default ProductCard